// Compare two dotted version strings like "6.1" or "4.2.0".
// Returns negative if a < b, positive if a > b, zero if equal.
// Missing trailing segments are treated as 0.
export const compareVersions = (a: string, b: string): number => {
    const pa = a.split(".").map(Number);
    const pb = b.split(".").map(Number);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const diff = (pa[i] || 0) - (pb[i] || 0);
        if (diff !== 0) return diff;
    }
    return 0;
};
